module.exports = "/packs/images/svg/ireland/facilities/building_facilities~f49ae1982f21a1b0a6e8fbc50675144e.svg";